(() => {
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

  function selectionCards(root) {
    root.querySelectorAll('.gift-wrap__choices, [data-variant-buttons]').forEach(group => {
      if (group.dataset.motionReady) return;
      group.dataset.motionReady = 'true';
      const ring = document.createElement('span');
      ring.className = 'selection-ring'; ring.setAttribute('aria-hidden', 'true');
      const originMarker = document.createElement('span');originMarker.className='selection-origin';originMarker.setAttribute('aria-hidden','true');
      group.append(originMarker,ring);
      let previous, animation;
      const update = (animate = false) => {
        const selected = group.querySelector('[data-gift-design]:checked + .gift-wrap__tile, [data-variant-id][aria-pressed="true"]');
        if (!selected || !selected.getClientRects().length) {ring.hidden = true; previous = null; return;}
        ring.hidden = false;
        // Measure the actual absolute origin, including a fieldset's legend offset.
        const origin = originMarker.getBoundingClientRect(), rect = selected.getBoundingClientRect();
        const current = {x:rect.left - origin.left, y:rect.top - origin.top, width:rect.width, height:rect.height};
        if (previous && Object.keys(current).every(key => Math.abs(previous[key]-current[key]) < .5)) return;
        const frame = value => ({transform:`translate(${value.x}px, ${value.y}px)`,width:`${value.width}px`,height:`${value.height}px`});
        animation?.cancel();
        Object.assign(ring.style, frame(current));
        if (animate && previous && !reduced()) animation = ring.animate([frame(previous), frame(current)], {duration:280,easing:'cubic-bezier(.2,.8,.2,1)'});
        previous = current;
      };
      group.addEventListener('change', () => update(true));
      group.addEventListener('click', () => update(true));
      const observer = new MutationObserver(() => update(true));
      group.querySelectorAll('[data-variant-id]').forEach(button => observer.observe(button,{attributes:true,attributeFilter:['aria-pressed']}));
      new ResizeObserver(() => update()).observe(group);
      update();
    });
  }

  function accordions(root) {
    root.querySelectorAll('details.product-accordion, details.description-details').forEach(details => {
      if (details.dataset.motionReady) return;
      details.dataset.motionReady = 'true';
      const summary = details.querySelector('summary'), content = details.querySelector(':scope > div');
      let animation, expanded = details.open;
      summary.addEventListener('click', event => {
        event.preventDefault();
        expanded = !expanded;
        const start = details.getBoundingClientRect().height;
        animation?.cancel();
        if (reduced()) {details.open = expanded; content.inert = !expanded; return;}
        details.open = true;
        content.inert = !expanded;
        const end = expanded ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height;
        details.classList.add('is-animating');
        animation = details.animate([{height:`${start}px`},{height:`${end}px`}],{duration:260,easing:'cubic-bezier(.2,.8,.2,1)'});
        animation.onfinish = () => {details.open = expanded;details.classList.remove('is-animating');animation = null;};
      });
    });
  }

  function giftSheets(root) {
    root.querySelectorAll('[data-gift-wrap]').forEach((widget,index) => {
      if (widget.dataset.sheetReady || !widget.querySelector('[data-gift-toggle]') || !HTMLDialogElement.prototype.showModal) return;
      widget.dataset.sheetReady = 'true';
      const form = widget.closest('form'), heading = widget.querySelector('h2');
      const content = document.createElement('div');content.className='gift-editor';
      while (heading.nextSibling) content.append(heading.nextSibling);
      widget.append(content);
      const dialog = document.createElement('dialog');dialog.className='gift-sheet';
      const titleId=`GiftSheetTitle-${index}`;
      dialog.setAttribute('aria-labelledby',titleId);
      const handle=document.createElement('div');handle.className='gift-sheet__handle';handle.setAttribute('aria-hidden','true');
      const header=document.createElement('div');header.className='gift-sheet__header';
      const title=document.createElement('h2');title.id=titleId;title.textContent='The finishing touch';
      const close=document.createElement('button');close.type='button';close.className='gift-sheet__close';close.textContent='×';close.setAttribute('aria-label','Close gift options');
      header.append(title,close);
      const scroller=document.createElement('div');scroller.className='gift-sheet__body';
      const footer=document.createElement('div');footer.className='gift-sheet__footer';
      dialog.append(handle,header,scroller,footer);
      const trigger=document.createElement('button');trigger.type='button';trigger.className='button gift-sheet-trigger';trigger.textContent='Choose gift options';trigger.setAttribute('aria-haspopup','dialog');
      const summary=document.createElement('p');summary.className='gift-sheet-summary';
      const mobile=matchMedia('(max-width: 749px)');
      const toggle=content.querySelector('[data-gift-toggle]');
      const feedback=content.querySelector('[data-gift-feedback]');
      const save=content.querySelector('.gift-wrap__apply');
      let opener, closing=false, oldOverflow='', dirty=false;
      const syncSummary=()=>{
        const design=content.querySelector('[data-gift-design]:checked')?.value;
        trigger.textContent=toggle.checked?'Edit gift options':'Choose gift options';
        summary.textContent=toggle.checked ? `${design || 'Choose your wrapping'}${content.querySelector('[data-gift-card-toggle]')?.checked?' · Personal card':''}${dirty?' · Not saved yet':''}` : dirty ? 'No gift wrap · Not saved yet' : toggle.closest('label').querySelector('small').textContent.trim();
      };
      const openSheet=()=>{
        if (!mobile.matches || dialog.open) return;
        opener=document.activeElement;oldOverflow=document.body.style.overflow;
        dialog.showModal();document.body.style.overflow='hidden';close.focus({preventScroll:true});
        if(!reduced()) dialog.animate([{transform:'translateY(100%)',opacity:.6},{transform:'translateY(0)',opacity:1}],{duration:320,easing:'cubic-bezier(.2,.8,.2,1)'});
      };
      const closeSheet=async()=>{
        if(!dialog.open || closing)return;
        closing=true;
        if(!reduced()) await dialog.animate([{transform:'translateY(0)',opacity:1},{transform:'translateY(100%)',opacity:.6}],{duration:200,easing:'ease-in'}).finished.catch(()=>{});
        dialog.close();closing=false;
      };
      dialog.addEventListener('close',()=>{document.body.style.overflow=oldOverflow;opener?.focus({preventScroll:true});syncSummary();});
      dialog.addEventListener('cancel',event=>{event.preventDefault();closeSheet();});
      close.addEventListener('click',closeSheet);
      dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const rect=dialog.getBoundingClientRect();if(event.clientY<rect.top || event.clientX<rect.left || event.clientX>rect.right || event.clientY>rect.bottom)closeSheet();});
      // Drag only the handle: scrolling fields or selecting text never dismisses the sheet.
      let startY;
      handle.addEventListener('pointerdown',event=>{startY=event.clientY;handle.setPointerCapture(event.pointerId);});
      handle.addEventListener('pointerup',event=>{if(startY!==undefined && event.clientY-startY>60)closeSheet();startY=undefined;});
      handle.addEventListener('pointercancel',()=>{startY=undefined;});
      trigger.addEventListener('click',openSheet);
      content.addEventListener('input',()=>{dirty=true;syncSummary();});
      content.addEventListener('change',()=>{dirty=true;syncSummary();});
      // Native form validation must reveal fields before the browser focuses them.
      form.addEventListener('invalid',event=>{if(content.contains(event.target))openSheet();},true);
      new MutationObserver(()=>{if(feedback.dataset.error==='true')openSheet();}).observe(feedback,{childList:true,attributes:true,attributeFilter:['data-error']});
      const layout=()=>{
        if(dialog.open){dialog.getAnimations().forEach(animation=>animation.cancel());dialog.close();}
        if(mobile.matches){scroller.append(content);footer.append(save,feedback);widget.append(trigger,summary,dialog);trigger.hidden=false;summary.hidden=false;}
        else{content.append(save,feedback);widget.append(content);trigger.hidden=true;summary.hidden=true;dialog.remove();}
        syncSummary();
      };
      mobile.addEventListener('change',layout);layout();
      document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(widget)){if(dialog.open)dialog.close();mobile.removeEventListener('change',layout);}});
    });
  }

  function init(root=document){giftSheets(root);selectionCards(root);accordions(root);}
  document.addEventListener('DOMContentLoaded',()=>init());
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
